/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstantiateFileTemplateRequest
 */
export interface InstantiateFileTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof InstantiateFileTemplateRequest
     */
    parent: number;
    /**
     * 
     * @type {string}
     * @memberof InstantiateFileTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof InstantiateFileTemplateRequest
     */
    customFields?: { [key: string]: string | undefined; };
}

export function InstantiateFileTemplateRequestFromJSON(json: any): InstantiateFileTemplateRequest {
    return InstantiateFileTemplateRequestFromJSONTyped(json, false);
}

export function InstantiateFileTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstantiateFileTemplateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parent': json['parent'],
        'name': json['name'],
        'customFields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
    };
}

export function InstantiateFileTemplateRequestToJSON(value?: InstantiateFileTemplateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parent': value.parent,
        'name': value.name,
        'custom_fields': value.customFields,
    };
}


